import { render, staticRenderFns } from "./UserVip.vue?vue&type=template&id=6d28732e&scoped=true&"
import script from "./UserVip.vue?vue&type=script&lang=js&"
export * from "./UserVip.vue?vue&type=script&lang=js&"
import style0 from "./UserVip.vue?vue&type=style&index=0&id=6d28732e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28732e",
  null
  
)

export default component.exports